import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10ed8888"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center justify-between mb-1 flex-wrap gap-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-black" }, "Registro de plantão", -1))
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "flex items-start gap-2 rounded-lg border border-primary bg-primary5 p-3 mb-2 text-sm text-left",
  "data-testid": "doctor-checks-readonly-banner"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Somente leitura.", -1))
const _hoisted_6 = { class: "flex flex-col w-full rounded-lg p-2 border-[2px] border-primary mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "cursor-pointer my-2 flex items-center gap-1 justify-between"
}
const _hoisted_8 = {
  key: 1,
  class: "flex gap-2 text-xs text-gray-500 font-bold"
}
const _hoisted_9 = {
  key: 1,
  class: "hidden md:flex w-full"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"w-[10%]\" data-v-10ed8888></div><div class=\"w-[20%] text-center\" data-v-10ed8888><h1 data-v-10ed8888>Checkin</h1></div><div class=\"w-[25%] text-center\" data-v-10ed8888><h1 data-v-10ed8888>Checkout</h1></div><div class=\"w-[15%] text-center\" data-v-10ed8888><h1 data-v-10ed8888>Registro</h1></div><div class=\"w-[25%] text-center\" data-v-10ed8888><h1 data-v-10ed8888>Evidência</h1></div><div class=\"w-[5%]\" data-v-10ed8888></div>", 6)
const _hoisted_16 = [
  _hoisted_10
]
const _hoisted_17 = {
  key: 2,
  class: "hidden md:flex w-full text-sm font-bold text-gray-500"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"w-[8%] text-center\" data-v-10ed8888>Principal</div><div class=\"w-[16%] text-center\" data-v-10ed8888>Check-in</div><div class=\"w-[16%] text-center\" data-v-10ed8888>Check-out</div><div class=\"w-[24%] text-center\" data-v-10ed8888>Registro (fonte)</div><div class=\"w-[16%] text-center\" data-v-10ed8888>Anexos</div><div class=\"w-[20%] text-center\" data-v-10ed8888>Ações</div>", 6)
const _hoisted_24 = [
  _hoisted_18
]
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { class: "hidden md:flex w-full items-center mt-3" }
const _hoisted_27 = { class: "w-[10%] h-[44px] flex items-center justify-center text-xs font-bold text-gray-500" }
const _hoisted_28 = ["data-testid", "aria-label"]
const _hoisted_29 = { class: "w-[20%] h-[40px] flex items-start" }
const _hoisted_30 = { class: "h-full mr-1" }
const _hoisted_31 = ["href"]
const _hoisted_32 = {
  key: 1,
  class: "w-[24px]"
}
const _hoisted_33 = { class: "w-[25%] h-[40px] flex items-start" }
const _hoisted_34 = { class: "h-full mr-1" }
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 1,
  class: "w-[24px]"
}
const _hoisted_37 = { class: "w-[15%] h-[44px] flex items-center justify-center text-xs font-bold text-gray-500 whitespace-nowrap" }
const _hoisted_38 = {
  key: 0,
  class: "w-[25%] h-auto flex flex-col items-center"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 0,
  class: "w-full"
}
const _hoisted_41 = {
  key: 1,
  class: "w-full"
}
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 0,
  class: "w-full"
}
const _hoisted_44 = { class: "w-full" }
const _hoisted_45 = {
  key: 1,
  class: "w-full"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block text-xs text-gray-500 text-center" }, "--", -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 1,
  class: "w-[25%] flex flex-col items-center"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block text-xs text-gray-500 text-center" }, "--", -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = ["disabled", "onClick"]
const _hoisted_52 = { class: "flex md:hidden flex-col gap-2 mt-3 p-3 border rounded-lg bg-gray-50" }
const _hoisted_53 = { class: "flex items-center gap-2" }
const _hoisted_54 = ["data-testid", "aria-label"]
const _hoisted_55 = { class: "text-xs font-bold text-gray-500" }
const _hoisted_56 = { class: "flex flex-col gap-1" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-xs text-gray-500 font-bold" }, "Check-in", -1))
const _hoisted_58 = { class: "flex items-center gap-1" }
const _hoisted_59 = ["href"]
const _hoisted_60 = { class: "flex flex-col gap-1" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-xs text-gray-500 font-bold" }, "Check-out", -1))
const _hoisted_62 = { class: "flex items-center gap-1" }
const _hoisted_63 = ["href"]
const _hoisted_64 = { class: "flex items-center justify-between" }
const _hoisted_65 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block text-xs text-gray-500 text-left" }, "--", -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = {
  key: 1,
  class: "block text-xs text-gray-500"
}
const _hoisted_75 = ["disabled", "onClick"]
const _hoisted_76 = {
  key: 4,
  "data-testid": "doctor-checks-readonly-table"
}
const _hoisted_77 = ["data-testid"]
const _hoisted_78 = { class: "w-[8%] flex justify-center" }
const _hoisted_79 = ["aria-label"]
const _hoisted_80 = { class: "w-[16%] flex flex-col items-center" }
const _hoisted_81 = { class: "font-mono" }
const _hoisted_82 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_83 = { class: "w-[16%] flex flex-col items-center" }
const _hoisted_84 = { class: "font-mono" }
const _hoisted_85 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_86 = { class: "w-[24%] flex flex-col items-center text-center gap-1" }
const _hoisted_87 = { class: "w-[16%] flex justify-center" }
const _hoisted_88 = ["data-testid", "onClick"]
const _hoisted_89 = ["data-testid"]
const _hoisted_90 = { class: "w-[20%] flex flex-col items-center gap-1" }
const _hoisted_91 = ["href", "data-testid"]
const _hoisted_92 = ["data-testid", "onClick"]
const _hoisted_93 = ["href", "data-testid"]
const _hoisted_94 = { class: "flex md:hidden flex-col gap-2 mt-3 p-3 border rounded-lg bg-gray-50 text-sm" }
const _hoisted_95 = { class: "flex items-center justify-between gap-2" }
const _hoisted_96 = { class: "font-bold text-gray-500" }
const _hoisted_97 = { class: "text-primary" }
const _hoisted_98 = { class: "flex flex-col gap-1" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Check-in:", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Check-out:", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Anexos:", -1))
const _hoisted_102 = { class: "flex items-center gap-3 flex-wrap" }
const _hoisted_103 = ["href"]
const _hoisted_104 = ["onClick"]
const _hoisted_105 = ["href"]
const _hoisted_106 = ["onClick"]
const _hoisted_107 = ["data-testid"]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fonte:", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Posição:", -1))
const _hoisted_110 = { key: 0 }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Método:", -1))
const _hoisted_112 = { key: 1 }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Coordenadas do check-in:", -1))
const _hoisted_114 = { key: 2 }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Coordenadas do check-out:", -1))
const _hoisted_116 = ["onDrop"]
const _hoisted_117 = { class: "mt-2 text-center" }
const _hoisted_118 = ["onClick"]
const _hoisted_119 = { key: 1 }
const _hoisted_120 = {
  key: 1,
  style: {"max-width":"200px"}
}
const _hoisted_121 = { class: "font-bold truncate" }
const _hoisted_122 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_123 = { class: "d-flex align-center pa-2" }
const _hoisted_124 = {
  key: 1,
  class: "d-flex align-center"
}
const _hoisted_125 = { key: 2 }
const _hoisted_126 = {
  key: 1,
  style: {"max-width":"200px"}
}
const _hoisted_127 = { class: "font-bold truncate" }
const _hoisted_128 = { class: "text-sm text-gray-500" }
const _hoisted_129 = { class: "d-flex align-center pa-2" }
const _hoisted_130 = {
  key: 1,
  class: "d-flex align-center"
}
const _hoisted_131 = { key: 0 }
const _hoisted_132 = ["title"]
const _hoisted_133 = {
  key: 0,
  class: "text-caption text-grey-darken-1 text-truncate mt-1",
  style: {"line-height":"1"}
}
const _hoisted_134 = {
  key: 0,
  class: "text-body-2 text-grey-darken-2 me-3 text-no-wrap",
  style: {"line-height":"1","padding-top":"2px"}
}

import { ref, computed, onMounted, watch } from 'vue'
import { utcToZonedTime } from 'date-fns-tz'
import { format } from 'date-fns'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import RoundedPlus from '@/assets/icons/rounded-plus.vue'
import EditPencilIcon from '@/assets/icons/edit-pencil.vue'
import {
  mdiTrashCanOutline,
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
  mdiMapMarkerRadius,
  mdiTrayArrowUp,
  mdiFileOutline,
  mdiCheckBold,
  mdiClose,
  mdiTrayArrowDown,
  mdiLockOutline
} from '@mdi/js'
import { CheckOrigin, HistoryDate, CheckEvidence } from '@/Network/Types/Requests/StationRequests'
import NetworkService from '@/Network'
import PATHS from '@/router/paths'
import { getCheckOriginLabel } from '@/utils/doctorStation'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import PermanenceLinkRow from '@/components/designSystem/Cards/PermanenceLinkRow.vue'
import EvidenceFlowDisabledModal from '@/modules/company/Dashboard/modals/updateStation/components/EvidenceFlowDisabledModal.vue'
import { getPermanenceLinkRows } from '@/utils/permanence'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useErrorToast } from '@/composables/useErrorToast'

/**
 * Uma linha da tabela. `dsAttendanceContainerId` deixou de ser suposição local: o
 * B17 (§1.2) o fixou em `doctorStation.doctorChecks[]` do `GET /stations/:id`, então
 * o campo mora agora no `HistoryDate` compartilhado. Continua opcional — o link
 * "ver registro #id" só aparece quando o backend diz de qual container a linha nasceu.
 */
type CheckRow = HistoryDate

/**
 * Aviso literal de M1 (Tela 2). Mora aqui, e não no template, porque o Vue
 * quebraria a frase em várias linhas de texto e ela chegaria picotada ao DOM.
 */
const MANUAL_CHECK_BLOCK_NOTICE =
  'O lançamento manual de check-in e check-out foi descontinuado para todos os perfis. ' +
  'Para corrigir um horário, use Enviar registro → Registro de Atividade; correções do ' +
  'backoffice usam o tipo Ajuste administrativo e passam pela mesma auditoria.'

type StagedFile = {
  id: number
  file: File
  eventType: 'Check-in' | 'Check-out' | 'Check-in e Check-out' | null
  newName: string
  isEditing: boolean
}

const maxFileSize = 5 * 1024 * 1024

// function fileSizeRule(files: File[] | null): true | string {
//   if (!files || files.length === 0) return true
//   for (const file of files) {
//     if (file.size > maxFileSize) {
//       return `O tamanho máximo permitido é ${maxFileSize / (1024 * 1024)} MB.`
//     }
//   }
//   return true
// }


export default /*#__PURE__*/_defineComponent({
  __name: 'doctor.checks',
  props: {
    stationId: {},
    infos: {},
    timezone: {},
    healthUnitLatitude: {},
    healthUnitLongitude: {},
    manualCheckBlockEnabled: { type: Boolean, default: false }
  },
  emits: [
  'saveChecks',
  'editModeChanged',
  'hasPendingChanges',
  'navigateToLinkedStation'
],
  setup(__props: any, { emit }) {

const props = __props;



/** Só o `true` explícito bloqueia — backend antigo (campo ausente) não muda nada. */
const isReadOnly = computed(() => props.manualCheckBlockEnabled === true)



const { flags } = useFeatureFlags()
const { notifyError } = useErrorToast()

const draftInformations = ref<CheckRow[]>([])
const isCheckMain = ref<number | undefined>(undefined)
const toggleEdit = ref<boolean>(false)
const informations = ref<CheckRow[]>([])
/** Linhas com o detalhe de "ver origem" aberto (M1, Tela 2). */
const openedSourceDetails = ref<Set<number>>(new Set())

const isRowMain = (index: number): boolean => index === isCheckMain.value

function attachmentCount(info: CheckRow): number {
  return (info.checkEvidences?.length ?? 0) || (info.evidence?.length ?? 0)
}

function attachmentLabel(info: CheckRow): string {
  const total = attachmentCount(info)
  if (total === 0) return '—'
  return total === 1 ? '1 anexo' : `${total} anexos`
}

/**
 * O mapa deixa de ser exclusivo da origem `DOCTOR`: a regra de M1 é "quando há
 * lat/long", venha a coordenada de onde vier.
 */
function mapsUrl(info: CheckRow): string | null {
  const latitude = info.checkinLatitude ?? info.checkoutLatitude
  const longitude = info.checkinLongitude ?? info.checkoutLongitude
  if (!latitude || !longitude) return null
  if (!props.healthUnitLatitude || !props.healthUnitLongitude) return null
  return `https://www.google.com/maps/dir/${latitude},${longitude}/${props.healthUnitLatitude},${props.healthUnitLongitude}`
}

/**
 * Um check só nasce quando o container é APROVADO (`syncDoctorChecksFromEntries`),
 * então a linha que veio de um container sempre aponta para a rota de aprovado.
 */
function containerUrl(info: CheckRow): string | null {
  const containerId = info.dsAttendanceContainerId
  if (!containerId) return null
  return PATHS.DS_ATTENDANCE_APPROVED.replace(':attendanceId', String(containerId))
}

function toggleSourceDetails(index: number): void {
  const opened = new Set(openedSourceDetails.value)
  if (opened.has(index)) opened.delete(index)
  else opened.add(index)
  openedSourceDetails.value = opened
}
const selectedFileNames = ref<CheckEvidence[][]>([])
const isSavingDraft = ref(false)
const hasBackendChanges = ref(false)

const eventTypeLabel = (v?: string | null) =>
  v === 'checkin'
    ? 'Check-in'
    : v === 'checkout'
      ? 'Check-out'
      : v === 'checkin-checkout'
        ? 'Check-in e Check-out'
        : (v ?? '')

const openEditMode = () => {
  if (isReadOnly.value) return
  toggleEdit.value = !toggleEdit.value
}

const hasChanges = computed(() => {
  if (!toggleEdit.value) return false

  const draft = draftInformations.value
  const original = informations.value

  if (draft.length !== original.length) return true

  // `isMain` saiu da comparação (BF5): não é mais editável nesta tela, então
  // nunca diverge entre rascunho e original por ação do usuário.
  // eslint-disable-next-line complexity
  return draft.some((draftItem, index) => {
    const originalItem = original[index]

    if (draftItem.checkin !== originalItem.checkin) return true
    if (draftItem.checkout !== originalItem.checkout) return true

    const draftCheckEvs = draftItem.checkEvidences || []
    const originalCheckEvs = originalItem.checkEvidences || []

    if (draftCheckEvs.length !== originalCheckEvs.length) return true

    const hasCheckEvDiff = draftCheckEvs.some((ev, evIndex) => {
      const orgEv = originalCheckEvs[evIndex]
      return ev.name !== orgEv.name || ev.eventType !== orgEv.eventType
    })
    if (hasCheckEvDiff) return true

    const draftEvidence = draftItem.evidence || []
    const originalEvidence = originalItem.evidence || []

    if (draftEvidence.length !== originalEvidence.length) return true

    const hasFileDiff = draftEvidence.some((file, fIndex) => {
      const orgFile = originalEvidence[fIndex]
      return (
        file.name !== orgFile.name ||
        file.size !== orgFile.size ||
        file.lastModified !== orgFile.lastModified
      )
    })
    if (hasFileDiff) return true

    return false
  })
})

watch(hasChanges, (newValue) => {
  console.log('hasChanges changed:', newValue)
  emit('hasPendingChanges', newValue)
})

const fileInput = ref<HTMLInputElement | null>(null)
const filesToUpload = ref<StagedFile[]>([])

function cancelEditName(item: StagedFile) {
  item.isEditing = false
  item.newName = item.file.name
}

function cancelEditCheckEvidenceName(item: CheckEvidence) {
  item.isEditing = false
  item.newName = item.name
}

function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

function triggerFileInput() {
  if (blockManualEvidenceUpload()) return

  fileInput.value?.click()
}

function addFilesToList(newFiles: FileList | null) {
  if (blockManualEvidenceUpload()) return
  if (!newFiles) return

  for (const file of Array.from(newFiles)) {
    if (file.size > maxFileSize) {
      alert(
        `O arquivo "${file.name}" excede o tamanho máximo de ${maxFileSize / (1024 * 1024)} MB.`
      )
      continue
    }

    if (!filesToUpload.value.some((f) => f.file.name === file.name && f.file.size === file.size)) {
      filesToUpload.value.push({
        id: Math.random() * 10000,
        file: file,
        eventType: null,
        newName: file.name,
        isEditing: false
      })
    }
  }
}

function onFileSelect(event: Event) {
  const target = event.target as HTMLInputElement
  addFilesToList(target.files)
  if (target) target.value = ''
}

function onDrop(event: DragEvent) {
  if (blockManualEvidenceUpload()) return

  addFilesToList(event.dataTransfer?.files || null)
}

function removeFile(index: number) {
  filesToUpload.value.splice(index, 1)
}

const isFormValid = computed(() => {
  const hasFiles = filesToUpload.value.length > 0

  if (hasFiles) {
    const allFilesValid = filesToUpload.value.every((f) => f.eventType)
    return allFilesValid
  }

  return hasBackendChanges.value
})

function submitFiles() {
  const index = currentCheckIndex.value

  console.log('Submitting files for check index:', index)

  if (index === undefined) return

  if (filesToUpload.value.length > 0) {
    console.log('Files to upload:', filesToUpload.value)
    const newFiles: File[] = filesToUpload.value.map((f) => {
      const originalName = f.file.name
      const lastDotIndex = originalName.lastIndexOf('.')

      if (lastDotIndex !== -1) {
        const extension = originalName.substring(lastDotIndex)
        if (!f.newName.toLowerCase().endsWith(extension.toLowerCase())) {
          f.newName += extension
        }
      }

      if (f.newName === f.file.name) {
        return f.file
      }
      return new File([f.file], f.newName, { type: f.file.type })
    })

    const newCheckEvidences: CheckEvidence[] = filesToUpload.value.map((f) => ({
      name: f.newName,
      path: '',
      eventType: f.eventType
    }))

    draftInformations.value[index].evidence = [
      ...(draftInformations.value[index].evidence || []),
      ...newFiles
    ]
    draftInformations.value[index].checkEvidences = [
      ...(draftInformations.value[index].checkEvidences || []),
      ...newCheckEvidences
    ]

    selectedFileNames.value[index] = [
      ...(selectedFileNames.value[index] || []),
      ...newCheckEvidences
    ]
  }

  closeModal()
}

function isIsoOffset(tz: string | undefined): boolean {
  if (!tz) return false
  if (tz === 'Z' || tz === 'z') return true
  const m = tz.match(/^([+-])(\d{2})(?::?(\d{2}))?$/)
  if (!m) return false
  return true
}

function parseDateSafely(dateString: string | null | undefined): Date | null {
  if (!dateString) return null
  const date = new Date(dateString)
  return isNaN(date.getTime()) ? null : date
}

function formatSafe(date: Date | null, formatStr: string): string {
  if (!date || isNaN(date.getTime())) return ''
  return format(date, formatStr)
}

function processChecks() {
  const tzInput = props.timezone ?? ''
  const timezoneOrDefaultTimezone = isIsoOffset(tzInput) ? tzInput : '-03:00'

  informations.value = (props.infos as CheckRow[]).map((v, i) => {
    if (v.isMain) isCheckMain.value = i

    const rawCheckin = parseDateSafely(v.checkin)
    const checkinDate = rawCheckin ? utcToZonedTime(rawCheckin, timezoneOrDefaultTimezone) : null

    const rawCheckout = parseDateSafely(v.checkout)
    const checkoutDate = rawCheckout ? utcToZonedTime(rawCheckout, timezoneOrDefaultTimezone) : null

    return {
      id: v.id,
      checkin: formatSafe(checkinDate, 'HH:mm'),
      labelCheckin: formatSafe(checkinDate, 'dd/MM/yyyy'),
      checkinLatitude: v.checkinLatitude,
      checkoutLongitude: v.checkoutLongitude,
      checkout: formatSafe(checkoutDate, 'HH:mm'),
      labelCheckout: formatSafe(checkoutDate, 'dd/MM/yyyy'),
      checkoutLatitude: v.checkoutLatitude,
      checkinLongitude: v.checkinLongitude,
      origin: v.origin ?? CheckOrigin.DOCTOR,
      isMain: v.isMain,
      checkEvidences: v.checkEvidences && v.checkEvidences.length > 0 ? v.checkEvidences : [],
      evidence: v.evidence || [],
      permanence: v.permanence ?? null,
      dsAttendanceContainerId: v.dsAttendanceContainerId ?? null
    }
  })
  draftInformations.value = informations.value.map((o) => ({ ...o }))
  selectedFileNames.value = draftInformations.value.map((item) => {
    if (item.checkEvidences && item.checkEvidences.length > 0) {
      return item.checkEvidences
    } else if (item.evidence && item.evidence.length > 0) {
      return item.evidence.map((file: File) => ({
        name: file.name,
        path: '',
        eventType: null
      }))
    }
    return []
  })
}

onMounted(() => {
  processChecks()
})

watch(
  () => props.infos,
  (newInfos) => {
    if (isSavingDraft.value) {
      isSavingDraft.value = false
      return
    }

    if (newInfos) {
      processChecks()
    }
  },
  { deep: true, immediate: true }
)

const colorHex = computed(() => (toggleEdit.value ? '#2F7F91' : '#D3D3D3'))
const colorText = computed(() => (toggleEdit.value ? 'text-primary' : 'text-gray-300'))
const borderColor = computed(() => (toggleEdit.value ? 'border-primary30' : 'border-gray-300'))

// Gate no consumo (não dentro de `PermanenceLinkRow.vue`): o componente é uma
// peça de apresentação pura, reutilizada tal-qual pela Task 7, seguindo o
// mesmo padrão de `LabelBadge`/`withIcon.vue` — quem decide se o vínculo
// aparece é quem consome, não o componente em si.
const permanenceLinks = computed(() =>
  flags.enabledPermanenceRecord ? getPermanenceLinkRows(props.infos) : []
)

function addNewCheck() {
  // Guardas de defesa: com o bloqueio ligado a UI nem oferece o caminho, mas o
  // método continua exportado para o modo legado — e a API recusa de todo jeito
  // (`MANUAL_CHECK_ENTRY_BLOCKED`).
  if (isReadOnly.value) return

  draftInformations.value.push({
    checkin: '',
    checkout: '',
    origin: CheckOrigin.WEB,
    isMain: false,
    evidence: []
  })

  selectedFileNames.value.push([])
}

function removeCheck(pos: number) {
  if (isReadOnly.value) return

  draftInformations.value = draftInformations.value.filter((_v, i) => i !== pos)

  selectedFileNames.value.splice(pos, 1)
}

function closeEditMode() {
  toggleEdit.value = false
  draftInformations.value = informations.value.map((o) => ({ ...o }))
}

function saveEditMode() {
  if (isReadOnly.value) return

  let validForm = true

  // `isMain` não é mais decidido aqui (BF5): o servidor reelege o principal em
  // `ensureMainCheck` e ignora o campo do payload (`StationService` já para de
  // enviá-lo). O valor local segue intacto só para o indicador de leitura.
  const newDrafts = draftInformations.value.map((c) => {
    if (!validateTime(c.checkin)) validForm = false
    return { ...c }
  })

  if (!validForm) return

  toggleEdit.value = false
  isSavingDraft.value = true
  emit('saveChecks', newDrafts)
  informations.value = newDrafts.map((o) => ({ ...o }))
}

function validateTime(hours: string) {
  const [hour, minutes] = hours.split(':')
  const isValidHours = Number(hour) >= 0 && Number(hour) <= 23
  const isValidMinutes = Number(minutes) >= 0 && Number(minutes) <= 59
  return isValidHours && isValidMinutes
}

const showModal = ref(false)
const flowDisabledOpen = ref(false)

/**
 * F2/Q32 — o bloqueio da inserção manual passa a ser de verdade, na API, e chega
 * ao web por `registration-settings` (`manualCheckBlockEnabled` → `isReadOnly`).
 *
 * O kill switch de front continua aqui como SEGUNDA TRAVA, e não por descuido:
 * ele está ligado em PROD desde 10/09 e a rota `registration-settings` ainda não
 * existe — enquanto ela responder 404, o campo cai no default `false` e só esta
 * flag segura o upload manual. Ordem de precedência:
 *
 * 1. `manualCheckBlockEnabled === true` → a aba inteira é somente leitura e nem
 *    existe caminho de upload (este guard nunca é alcançado);
 * 2. campo ausente/`false` → vale o comportamento de hoje, incluindo o modal
 *    "Procure sua liderança" quando a env var estiver ligada.
 *
 * A flag sai quando o backend da F2 estiver em PROD com `DS_MANUAL_CHECK_BLOCK_ENABLED`
 * ligado (§4.1/§10.4) — nunca antes.
 */
function blockManualEvidenceUpload(): boolean {
  if (!flags.disabledManualEvidenceUpload) return false

  flowDisabledOpen.value = true
  return true
}

const currentCheckIndex = ref<number>(0)
const showFilesModal = ref(false)
const modalFiles = ref<CheckEvidence[]>([])

function showFiles(fileNames: CheckEvidence[], index: number) {
  hasBackendChanges.value = false

  fileNames.forEach((f) => {
    if (f.isEditing === undefined) f.isEditing = false
    f.newName = f.name
  })

  modalFiles.value = fileNames
  currentCheckIndex.value = index

  console.log(
    'showFiles called with index:',
    index,
    'fileNames:',
    fileNames,
    'toggleEdit:',
    toggleEdit.value
  )
  if (toggleEdit.value) {
    showModal.value = true
  } else {
    showFilesModal.value = true
  }
}

function saveCheckEvidenceName(item: CheckEvidence & { isEditing?: boolean; newName?: string }) {
  console.log('Saving new name:', item.newName)
  if (item.newName && item.newName.trim() !== '') {
    const originalName = item.name
    const lastDotIndex = originalName.lastIndexOf('.')

    if (lastDotIndex !== -1) {
      const extension = originalName.substring(lastDotIndex)

      if (!item.newName.toLowerCase().endsWith(extension.toLowerCase())) {
        item.newName += extension
      }
    }
    console.log('Saving new name:', item.newName, 'original name:', originalName)
    if (item.name !== item.newName) {
      console.log('Name changed from', item.name, 'to', item.newName)
      item.name = item.newName
      hasBackendChanges.value = true
    }

    item.isEditing = false
  } else {
    item.newName = item.name
    item.isEditing = false
  }
}

function closeFilesModal() {
  showFilesModal.value = false
  showModal.value = false
}

function openModal(index: number) {
  if (isReadOnly.value) return
  // Bloqueio temporário do upload de evidência pelo painel (set/2026): com a env
  // var ligada o diálogo não abre e o modal de aviso aparece no lugar.
  if (blockManualEvidenceUpload()) return

  hasBackendChanges.value = false
  modalFiles.value = []
  currentCheckIndex.value = index

  if (toggleEdit.value) {
    showModal.value = true
  } else {
    showFilesModal.value = true
  }
}

// function showFiles(fileNames: CheckEvidence[], index: number) {

//   hasBackendChanges.value = false

//   fileNames.forEach(f => {
//     if (f.isEditing === undefined) f.isEditing = false
//     f.newName = f.name
//   })

//   modalFiles.value = fileNames
//   currentCheckIndex.value = index
//   showFilesModal.value = true
// }

function closeModal() {
  showModal.value = false
  showFilesModal.value = false
  filesToUpload.value = []
}

/**
 * Baixa a evidência de check via endpoint autenticado e abre o blob local
 * em nova aba. Evita expor a URL crua do Azure Blob (que agora é um token
 * cifrado opaco em `item.path`).
 */
async function downloadEvidence(evidenceId: number | undefined) {
  if (!evidenceId) return
  try {
    const blob = await NetworkService.doctorCheckEvidence.downloadCheckEvidenceFile(
      props.stationId,
      evidenceId
    )
    const blobUrl = URL.createObjectURL(blob)
    window.open(blobUrl, '_blank')
  } catch (err) {
    console.error('Falha ao baixar evidência de check:', err)
    // Antes: swallow com console.error — o clique em baixar falhava em silêncio.
    notifyError(err, 'Não foi possível baixar a evidência de registro')
  }
}

function removeBackendFile(index: number) {
  const checkIdx = currentCheckIndex.value

  if (checkIdx === undefined) return

  hasBackendChanges.value = true

  modalFiles.value.splice(index, 1)

  if (draftInformations.value[checkIdx]) {
    draftInformations.value[checkIdx].checkEvidences = [...modalFiles.value]

    selectedFileNames.value[checkIdx] = [...modalFiles.value]
  }
}

function downloadLocalFile(file: File) {
  if (!file) return

  const url = URL.createObjectURL(file)

  const link = document.createElement('a')
  link.href = url
  link.download = file.name

  document.body.appendChild(link)

  link.click()

  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (!isReadOnly.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: addNewCheck,
            class: _normalizeClass(["flex items-center justify-center cursor-pointer border rounded-md py-1 px-3", borderColor.value])
          }, [
            _createElementVNode("button", {
              disabled: !toggleEdit.value,
              class: "flex gap-2 md:gap-4 items-center"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["font-bold text-sm hidden md:inline", colorText.value])
              }, "Adicionar registro de presença", 2),
              _createElementVNode("span", {
                class: _normalizeClass(["font-bold text-sm md:hidden", colorText.value])
              }, "Adicionar", 2),
              _createVNode(RoundedPlus, { color: colorHex.value }, null, 8, ["color"])
            ], 8, _hoisted_3)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (isReadOnly.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_icon, {
            icon: _unref(mdiLockOutline),
            color: "primary",
            size: "20",
            class: "shrink-0 mt-[2px]"
          }, null, 8, ["icon"]),
          _createElementVNode("span", null, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(MANUAL_CHECK_BLOCK_NOTICE))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (!isReadOnly.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (!toggleEdit.value)
              ? (_openBlock(), _createBlock(EditPencilIcon, {
                  key: 0,
                  onClick: openEditMode,
                  color: "#2F7F91"
                }))
              : _createCommentVNode("", true),
            (toggleEdit.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", { onClick: saveEditMode }, [
                    _createVNode(_component_v_icon, {
                      icon: _unref(mdiCheckCircleOutline),
                      color: "#22bb33",
                      class: "cursor-pointer"
                    }, null, 8, ["icon"]),
                    _createTextVNode(" Salvar Rascunho ")
                  ]),
                  _createElementVNode("span", { onClick: closeEditMode }, [
                    _createVNode(_component_v_icon, {
                      icon: _unref(mdiCloseCircleOutline),
                      color: "#bb2124",
                      class: "cursor-pointer"
                    }, null, 8, ["icon"]),
                    _createTextVNode(" Descartar Rascunho ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!isReadOnly.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_16))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_24)),
      (!isReadOnly.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(draftInformations.value, (info, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", {
                      type: "button",
                      disabled: "",
                      class: "text-primary cursor-default",
                      "data-testid": `doctor-checks-main-indicator-${i}`,
                      "aria-label": isRowMain(i) ? 'Registro principal' : 'Registro não principal'
                    }, _toDisplayString(isRowMain(i) ? '●' : '○'), 9, _hoisted_28)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      (
                  info.origin === 'DOCTOR' &&
                  info.checkinLatitude &&
                  info.checkinLongitude &&
                  _ctx.healthUnitLatitude &&
                  _ctx.healthUnitLongitude
                )
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "h-full flex justify-center items-center",
                            href: `https://www.google.com/maps/dir/${info.checkinLatitude},${info.checkinLongitude}/${_ctx.healthUnitLatitude},${_ctx.healthUnitLongitude}`,
                            target: "_blank"
                          }, [
                            _createVNode(_component_v_icon, {
                              class: "hover:cursor-pointer",
                              icon: _unref(mdiMapMarkerRadius),
                              color: "primary"
                            }, null, 8, ["icon"])
                          ], 8, _hoisted_31))
                        : (_openBlock(), _createElementBlock("div", _hoisted_32))
                    ]),
                    _withDirectives(_createVNode(GenericInput, {
                      disabled: !toggleEdit.value || info.origin === 'DOCTOR',
                      modelValue: info.checkin,
                      "onUpdate:modelValue": ($event: any) => ((info.checkin) = $event),
                      name: "checkin",
                      density: "compact",
                      label: info.labelCheckin || '',
                      width: "300px",
                      variant: "outlined"
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "label"]), [
                      [_directive_maska, '##:##']
                    ]),
                    (_unref(flags).enabledPermanenceRecord && info.permanence?.autoCheckin)
                      ? (_openBlock(), _createBlock(LabelBadge, {
                          key: 0,
                          label: "🔗 PERMANÊNCIA",
                          color: "blue",
                          size: "small",
                          icon: null,
                          class: "ml-1 shrink-0 self-center",
                          "data-testid": "permanence-checkin-chip"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      (
                  info.origin === 'DOCTOR' &&
                  info.checkoutLatitude &&
                  info.checkoutLongitude &&
                  _ctx.healthUnitLatitude &&
                  _ctx.healthUnitLongitude
                )
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "h-full flex justify-center items-center",
                            href: `https://www.google.com/maps/dir/${info.checkoutLatitude},${info.checkoutLongitude}/${_ctx.healthUnitLatitude},${_ctx.healthUnitLongitude}`,
                            target: "_blank"
                          }, [
                            _createVNode(_component_v_icon, {
                              class: "hover:cursor-pointer",
                              icon: _unref(mdiMapMarkerRadius),
                              color: "primary"
                            }, null, 8, ["icon"])
                          ], 8, _hoisted_35))
                        : (_openBlock(), _createElementBlock("div", _hoisted_36))
                    ]),
                    _withDirectives(_createVNode(GenericInput, {
                      disabled: !toggleEdit.value || info.origin === 'DOCTOR',
                      modelValue: info.checkout,
                      "onUpdate:modelValue": ($event: any) => ((info.checkout) = $event),
                      name: "checkout",
                      density: "compact",
                      label: info.labelCheckout || '',
                      width: "100%",
                      "onClick:prepend": _cache[0] || (_cache[0] = 
                (e) => {
                  console.log('prepend', e)
                }
              ),
                      variant: "outlined"
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "label"]), [
                      [_directive_maska, '##:##']
                    ]),
                    (_unref(flags).enabledPermanenceRecord && info.permanence?.autoCheckout)
                      ? (_openBlock(), _createBlock(LabelBadge, {
                          key: 0,
                          label: "🔗 PERMANÊNCIA",
                          color: "blue",
                          size: "small",
                          icon: null,
                          class: "ml-1 shrink-0 self-center",
                          "data-testid": "permanence-checkout-chip"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(getCheckOriginLabel)(info.origin)), 1),
                  (info.origin === 'WEB')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        (toggleEdit.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              (
                    (!draftInformations.value[i]?.evidence ||
                      draftInformations.value[i]?.evidence?.length === 0) &&
                    (!draftInformations.value[i]?.checkEvidences ||
                      draftInformations.value[i]?.checkEvidences?.length === 0)
                  )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _createVNode(_component_v_btn, {
                                      color: "primary",
                                      depressed: "",
                                      class: "text-xs w-full md:w-[200px]",
                                      onClick: ($event: any) => (openModal(i))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Selecionar Arquivos ")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _createVNode(_component_v_btn, {
                                      color: "primary",
                                      depressed: "",
                                      class: "text-xs w-full md:w-[200px]",
                                      onClick: ($event: any) => (showFiles(selectedFileNames.value[i], i))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedFileNames.value[i].length) + " Arquivos ", 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              (
                    (draftInformations.value[i]?.checkEvidences?.length ?? 0) > 0 ||
                    (draftInformations.value[i]?.evidence?.length ?? 0) > 0
                  )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                      _createVNode(_component_v_btn, {
                                        color: "primary",
                                        depressed: "",
                                        class: "text-xs w-full md:w-[200px]",
                                        onClick: ($event: any) => (showFiles(selectedFileNames.value[i], i))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(selectedFileNames.value[i].length) + " Arquivos ", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                            ]))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50)),
                  _createElementVNode("button", {
                    disabled: !toggleEdit.value || info.origin === 'DOCTOR',
                    onClick: ($event: any) => (removeCheck(i)),
                    class: "w-[5%] h-[44px] flex items-center",
                    "data-testid": "doctor-checks-remove-row"
                  }, [
                    _createVNode(_component_v_icon, {
                      icon: _unref(mdiTrashCanOutline),
                      color: info.origin === 'DOCTOR' ? 'error' : colorHex.value
                    }, null, 8, ["icon", "color"])
                  ], 8, _hoisted_51)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("button", {
                      type: "button",
                      disabled: "",
                      class: "text-primary cursor-default",
                      "data-testid": `doctor-checks-main-indicator-mobile-${i}`,
                      "aria-label": isRowMain(i) ? 'Registro principal' : 'Registro não principal'
                    }, _toDisplayString(isRowMain(i) ? '●' : '○'), 9, _hoisted_54),
                    _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(getCheckOriginLabel)(info.origin)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _createElementVNode("div", _hoisted_58, [
                      (
                  info.origin === 'DOCTOR' &&
                  info.checkinLatitude &&
                  info.checkinLongitude &&
                  _ctx.healthUnitLatitude &&
                  _ctx.healthUnitLongitude
                )
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "flex justify-center items-center",
                            href: `https://www.google.com/maps/dir/${info.checkinLatitude},${info.checkinLongitude}/${_ctx.healthUnitLatitude},${_ctx.healthUnitLongitude}`,
                            target: "_blank"
                          }, [
                            _createVNode(_component_v_icon, {
                              class: "hover:cursor-pointer",
                              icon: _unref(mdiMapMarkerRadius),
                              color: "primary"
                            }, null, 8, ["icon"])
                          ], 8, _hoisted_59))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(GenericInput, {
                        disabled: !toggleEdit.value || info.origin === 'DOCTOR',
                        modelValue: info.checkin,
                        "onUpdate:modelValue": ($event: any) => ((info.checkin) = $event),
                        name: "checkin",
                        density: "compact",
                        label: info.labelCheckin || '',
                        width: "100%",
                        variant: "outlined"
                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "label"]), [
                        [_directive_maska, '##:##']
                      ]),
                      (_unref(flags).enabledPermanenceRecord && info.permanence?.autoCheckin)
                        ? (_openBlock(), _createBlock(LabelBadge, {
                            key: 1,
                            label: "🔗 PERMANÊNCIA",
                            color: "blue",
                            size: "small",
                            icon: null,
                            "data-testid": "permanence-checkin-chip"
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      (
                  info.origin === 'DOCTOR' &&
                  info.checkoutLatitude &&
                  info.checkoutLongitude &&
                  _ctx.healthUnitLatitude &&
                  _ctx.healthUnitLongitude
                )
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "flex justify-center items-center",
                            href: `https://www.google.com/maps/dir/${info.checkoutLatitude},${info.checkoutLongitude}/${_ctx.healthUnitLatitude},${_ctx.healthUnitLongitude}`,
                            target: "_blank"
                          }, [
                            _createVNode(_component_v_icon, {
                              class: "hover:cursor-pointer",
                              icon: _unref(mdiMapMarkerRadius),
                              color: "primary"
                            }, null, 8, ["icon"])
                          ], 8, _hoisted_63))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(GenericInput, {
                        disabled: !toggleEdit.value || info.origin === 'DOCTOR',
                        modelValue: info.checkout,
                        "onUpdate:modelValue": ($event: any) => ((info.checkout) = $event),
                        name: "checkout",
                        density: "compact",
                        label: info.labelCheckout || '',
                        width: "100%",
                        variant: "outlined"
                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "label"]), [
                        [_directive_maska, '##:##']
                      ]),
                      (_unref(flags).enabledPermanenceRecord && info.permanence?.autoCheckout)
                        ? (_openBlock(), _createBlock(LabelBadge, {
                            key: 1,
                            label: "🔗 PERMANÊNCIA",
                            color: "blue",
                            size: "small",
                            icon: null,
                            "data-testid": "permanence-checkout-chip"
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    (info.origin === 'WEB')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          (toggleEdit.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                (
                      (!draftInformations.value[i]?.evidence ||
                        draftInformations.value[i]?.evidence?.length === 0) &&
                      (!draftInformations.value[i]?.checkEvidences ||
                        draftInformations.value[i]?.checkEvidences?.length === 0)
                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                      _createVNode(_component_v_btn, {
                                        color: "primary",
                                        depressed: "",
                                        class: "text-xs w-full",
                                        onClick: ($event: any) => (openModal(i))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Selecionar Arquivos ")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                      _createVNode(_component_v_btn, {
                                        color: "primary",
                                        depressed: "",
                                        class: "text-xs w-full",
                                        onClick: ($event: any) => (showFiles(selectedFileNames.value[i], i))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(selectedFileNames.value[i].length) + " Arquivos ", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                (
                      (draftInformations.value[i]?.checkEvidences?.length ?? 0) > 0 ||
                      (draftInformations.value[i]?.evidence?.length ?? 0) > 0
                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                      _createVNode(_component_v_btn, {
                                        color: "primary",
                                        depressed: "",
                                        class: "text-xs w-full",
                                        onClick: ($event: any) => (showFiles(selectedFileNames.value[i], i))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(selectedFileNames.value[i].length) + " Arquivos ", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_71, _hoisted_73))
                              ]))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_74, "--")),
                    _createElementVNode("button", {
                      disabled: !toggleEdit.value || info.origin === 'DOCTOR',
                      onClick: ($event: any) => (removeCheck(i)),
                      class: "ml-2 h-[44px] flex items-center",
                      "data-testid": "doctor-checks-remove-row"
                    }, [
                      _createVNode(_component_v_icon, {
                        icon: _unref(mdiTrashCanOutline),
                        color: info.origin === 'DOCTOR' ? 'error' : colorHex.value
                      }, null, 8, ["icon", "color"])
                    ], 8, _hoisted_75)
                  ])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_76, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(draftInformations.value, (info, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `readonly-${i}`
              }, [
                _createElementVNode("div", {
                  class: "hidden md:flex w-full items-center mt-3 pb-2 border-b border-gray-100 text-sm",
                  "data-testid": `doctor-checks-readonly-row-${i}`
                }, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("button", {
                      type: "button",
                      disabled: "",
                      class: "text-primary cursor-default",
                      "data-testid": "doctor-checks-main-radio",
                      "aria-label": isRowMain(i) ? 'Registro principal' : 'Registro não principal'
                    }, _toDisplayString(isRowMain(i) ? '●' : '○'), 9, _hoisted_79)
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("span", _hoisted_81, _toDisplayString(info.checkin || '—'), 1),
                    (info.labelCheckin)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(info.labelCheckin), 1))
                      : _createCommentVNode("", true),
                    (_unref(flags).enabledPermanenceRecord && info.permanence?.autoCheckin)
                      ? (_openBlock(), _createBlock(LabelBadge, {
                          key: 1,
                          label: "🔗 PERMANÊNCIA",
                          color: "blue",
                          size: "small",
                          icon: null,
                          class: "mt-1",
                          "data-testid": "permanence-checkin-chip"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("span", _hoisted_84, _toDisplayString(info.checkout || '—'), 1),
                    (info.labelCheckout)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(info.labelCheckout), 1))
                      : _createCommentVNode("", true),
                    (_unref(flags).enabledPermanenceRecord && info.permanence?.autoCheckout)
                      ? (_openBlock(), _createBlock(LabelBadge, {
                          key: 1,
                          label: "🔗 PERMANÊNCIA",
                          color: "blue",
                          size: "small",
                          icon: null,
                          class: "mt-1",
                          "data-testid": "permanence-checkout-chip"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("span", null, _toDisplayString(_unref(getCheckOriginLabel)(info.origin)), 1),
                    (!isRowMain(i))
                      ? (_openBlock(), _createBlock(LabelBadge, {
                          key: 0,
                          label: "descartada",
                          color: "gray",
                          size: "small",
                          icon: null,
                          "data-testid": `doctor-checks-superseded-${i}`
                        }, null, 8, ["data-testid"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    (attachmentCount(info) > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "text-primary underline",
                          "data-testid": `doctor-checks-attachments-${i}`,
                          onClick: ($event: any) => (showFiles(selectedFileNames.value[i], i))
                        }, _toDisplayString(attachmentLabel(info)), 9, _hoisted_88))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "text-gray-500",
                          "data-testid": `doctor-checks-attachments-${i}`
                        }, " — ", 8, _hoisted_89))
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    (mapsUrl(info))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "text-primary underline",
                          href: mapsUrl(info) || undefined,
                          target: "_blank",
                          rel: "noopener",
                          "data-testid": `doctor-checks-map-link-${i}`
                        }, " Ver mapa ", 8, _hoisted_91))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-primary underline",
                      "data-testid": `doctor-checks-source-toggle-${i}`,
                      onClick: ($event: any) => (toggleSourceDetails(i))
                    }, " ver origem ", 8, _hoisted_92),
                    (containerUrl(info))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "text-primary underline",
                          href: containerUrl(info) || undefined,
                          target: "_blank",
                          rel: "noopener",
                          "data-testid": `doctor-checks-container-link-${i}`
                        }, " ver registro #" + _toDisplayString(info.dsAttendanceContainerId), 9, _hoisted_93))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_77),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("span", _hoisted_96, _toDisplayString(_unref(getCheckOriginLabel)(info.origin)), 1),
                    _createElementVNode("span", _hoisted_97, _toDisplayString(isRowMain(i) ? '● Principal' : '○'), 1)
                  ]),
                  (!isRowMain(i))
                    ? (_openBlock(), _createBlock(LabelBadge, {
                        key: 0,
                        label: "descartada",
                        color: "gray",
                        size: "small",
                        icon: null
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("span", null, [
                      _hoisted_99,
                      _createTextVNode(" " + _toDisplayString(info.checkin || '—'), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _hoisted_100,
                      _createTextVNode(" " + _toDisplayString(info.checkout || '—'), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _hoisted_101,
                      _createTextVNode(" " + _toDisplayString(attachmentLabel(info)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    (mapsUrl(info))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "text-primary underline",
                          href: mapsUrl(info) || undefined,
                          target: "_blank",
                          rel: "noopener"
                        }, " Ver mapa ", 8, _hoisted_103))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-primary underline",
                      onClick: ($event: any) => (toggleSourceDetails(i))
                    }, " ver origem ", 8, _hoisted_104),
                    (containerUrl(info))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "text-primary underline",
                          href: containerUrl(info) || undefined,
                          target: "_blank",
                          rel: "noopener"
                        }, " ver registro #" + _toDisplayString(info.dsAttendanceContainerId), 9, _hoisted_105))
                      : _createCommentVNode("", true),
                    (attachmentCount(info) > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          class: "text-primary underline",
                          onClick: ($event: any) => (showFiles(selectedFileNames.value[i], i))
                        }, _toDisplayString(attachmentLabel(info)), 9, _hoisted_106))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (openedSourceDetails.value.has(i))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "mt-1 mb-2 p-3 rounded-lg bg-gray-50 text-xs text-left",
                      "data-testid": `doctor-checks-source-details-${i}`
                    }, [
                      _createElementVNode("div", null, [
                        _hoisted_108,
                        _createTextVNode(" " + _toDisplayString(_unref(getCheckOriginLabel)(info.origin)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_109,
                        _createTextVNode(" " + _toDisplayString(isRowMain(i) ? 'fonte vigente do horário efetivo' : 'superada no ranking'), 1)
                      ]),
                      (info.permanence?.autoCheckin || info.permanence?.autoCheckout)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                            _hoisted_111,
                            _createTextVNode(" permanência automática ")
                          ]))
                        : _createCommentVNode("", true),
                      (info.checkinLatitude && info.checkinLongitude)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                            _hoisted_113,
                            _createTextVNode(" " + _toDisplayString(info.checkinLatitude) + ", " + _toDisplayString(info.checkinLongitude), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (info.checkoutLatitude && info.checkoutLongitude)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                            _hoisted_115,
                            _createTextVNode(" " + _toDisplayString(info.checkoutLatitude) + ", " + _toDisplayString(info.checkoutLongitude), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_107))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permanenceLinks.value, (link) => {
        return (_openBlock(), _createBlock(PermanenceLinkRow, {
          key: `${link.direction}-${link.recordId}`,
          direction: link.direction,
          "station-label": link.stationLabel,
          "doctor-station-id": link.doctorStationId,
          "station-id": link.stationId,
          onNavigate: _cache[1] || (_cache[1] = (stationId) => emit('navigateToLinkedStation', stationId))
        }, null, 8, ["direction", "station-label", "doctor-station-id", "station-id"]))
      }), 128))
    ]),
    _createVNode(EvidenceFlowDisabledModal, {
      modelValue: flowDisabledOpen.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((flowDisabledOpen).value = $event))
    }, null, 8, ["modelValue"]),
    (!isReadOnly.value)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 1,
          modelValue: showModal.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showModal).value = $event)),
          "max-width": "700"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { color: "primary" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Selecione os arquivos")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    (!_unref(flags).disabledManualEvidenceUpload)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          color: "primary",
                          class: "custom-dropzone",
                          "data-testid": "doctor-checks-dropzone",
                          onDrop: _withModifiers(onDrop, ["prevent"]),
                          onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                        }, [
                          _createVNode(_component_v_icon, {
                            size: "64",
                            color: "primary",
                            icon: _unref(mdiTrayArrowUp)
                          }, null, 8, ["icon"]),
                          _createElementVNode("div", _hoisted_117, [
                            _createTextVNode(" Arraste os arquivos ou "),
                            _createElementVNode("a", {
                              class: "text-bold text-primary",
                              href: "#",
                              onClick: _withModifiers(triggerFileInput, ["prevent"])
                            }, "clique aqui", 8, _hoisted_118),
                            _createTextVNode(" para selecionar ")
                          ])
                        ], 40, _hoisted_116))
                      : _createCommentVNode("", true),
                    _createElementVNode("input", {
                      type: "file",
                      ref_key: "fileInput",
                      ref: fileInput,
                      onChange: onFileSelect,
                      multiple: "",
                      hidden: ""
                    }, null, 544),
                    (modalFiles.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modalFiles.value, (item, index) => {
                            return (_openBlock(), _createBlock(_component_v_sheet, {
                              key: item.id,
                              class: "file-list-item",
                              variant: "outlined",
                              rounded: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  class: "file-list-item-row",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          size: "40",
                                          color: "primary",
                                          class: "ml-0",
                                          icon: _unref(mdiFileOutline)
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { class: "col-texto-flexivel" }, {
                                      default: _withCtx(() => [
                                        (item.isEditing)
                                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                                              key: 0,
                                              modelValue: item.newName,
                                              "onUpdate:modelValue": ($event: any) => ((item.newName) = $event),
                                              density: "compact",
                                              "hide-details": "",
                                              autofocus: "",
                                              onKeydown: _withKeys(($event: any) => (item.isEditing = false), ["enter"])
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                              _createElementVNode("div", _hoisted_121, _toDisplayString(item.name), 1),
                                              (item.size)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_122, _toDisplayString(formatBytes(item.size)), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_123, [
                                          _createVNode(_component_v_autocomplete, {
                                            modelValue: item.eventType,
                                            "onUpdate:modelValue": [
                                              ($event: any) => ((item.eventType) = $event),
                                              _cache[4] || (_cache[4] = ($event: any) => (hasBackendChanges.value = true))
                                            ],
                                            items: ['Check-in', 'Check-out', 'Check-in e Check-out'],
                                            label: "Categoria",
                                            style: {"width":"100%","max-width":"250px"},
                                            variant: "outlined",
                                            density: "comfortable",
                                            color: "primary20",
                                            "base-color": "primary20",
                                            "auto-select-first": true,
                                            "hide-details": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (item.id)
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          cols: "auto"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              icon: "",
                                              variant: "text",
                                              color: "primary",
                                              onClick: _withModifiers(($event: any) => (downloadEvidence(item.id)), ["stop"]),
                                              density: "compact"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                  size: "24",
                                                  icon: _unref(mdiTrayArrowDown)
                                                }, null, 8, ["icon"])
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => [
                                        (!item.isEditing)
                                          ? (_openBlock(), _createBlock(EditPencilIcon, {
                                              key: 0,
                                              color: "#2F7F91",
                                              class: "cursor-pointer",
                                              onClick: ($event: any) => (item.isEditing = true)
                                            }, null, 8, ["onClick"]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                              _createVNode(_component_v_icon, {
                                                icon: _unref(mdiCheckBold),
                                                color: "primary",
                                                class: "cursor-pointer",
                                                onClick: ($event: any) => (saveCheckEvidenceName(item))
                                              }, null, 8, ["icon", "onClick"]),
                                              _createVNode(_component_v_icon, {
                                                icon: _unref(mdiClose),
                                                color: "primary",
                                                class: "cursor-pointer ml-1",
                                                onClick: ($event: any) => (cancelEditCheckEvidenceName(item))
                                              }, null, 8, ["icon", "onClick"])
                                            ]))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          icon: _unref(mdiCloseCircleOutline),
                                          color: "#2F7F91",
                                          class: "cursor-pointer",
                                          onClick: ($event: any) => (removeBackendFile(index))
                                        }, null, 8, ["icon", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (filesToUpload.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filesToUpload.value, (item, index) => {
                            return (_openBlock(), _createBlock(_component_v_sheet, {
                              key: item.id,
                              class: "file-list-item",
                              variant: "outlined",
                              rounded: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  class: "file-list-item-row",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          size: "40",
                                          color: "primary",
                                          class: "ml-0",
                                          icon: _unref(mdiFileOutline)
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { class: "col-texto-flexivel" }, {
                                      default: _withCtx(() => [
                                        (item.isEditing)
                                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                                              key: 0,
                                              modelValue: item.newName,
                                              "onUpdate:modelValue": ($event: any) => ((item.newName) = $event),
                                              density: "compact",
                                              "hide-details": "",
                                              autofocus: "",
                                              onKeydown: _withKeys(($event: any) => (item.isEditing = false), ["enter"])
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                              _createElementVNode("div", _hoisted_127, _toDisplayString(item.newName), 1),
                                              _createElementVNode("div", _hoisted_128, _toDisplayString(formatBytes(item.file.size)), 1)
                                            ]))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_129, [
                                          _createVNode(_component_v_autocomplete, {
                                            modelValue: item.eventType,
                                            "onUpdate:modelValue": ($event: any) => ((item.eventType) = $event),
                                            items: ['Check-in', 'Check-out', 'Check-in e Check-out'],
                                            label: "Categoria",
                                            style: {"width":"100%","max-width":"250px"},
                                            variant: "outlined",
                                            density: "comfortable",
                                            color: "primary20",
                                            "base-color": "primary20",
                                            "auto-select-first": true,
                                            "hide-details": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          variant: "text",
                                          color: "primary",
                                          onClick: _withModifiers(($event: any) => (downloadLocalFile(item.file)), ["stop"]),
                                          density: "compact"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              size: "24",
                                              icon: _unref(mdiTrayArrowDown)
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => [
                                        (!item.isEditing)
                                          ? (_openBlock(), _createBlock(EditPencilIcon, {
                                              key: 0,
                                              color: "#2F7F91",
                                              class: "cursor-pointer",
                                              onClick: ($event: any) => (item.isEditing = true)
                                            }, null, 8, ["onClick"]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                              _createVNode(_component_v_icon, {
                                                icon: _unref(mdiCheckBold),
                                                color: "primary",
                                                class: "cursor-pointer",
                                                onClick: ($event: any) => (item.isEditing = false)
                                              }, null, 8, ["icon", "onClick"]),
                                              _createVNode(_component_v_icon, {
                                                icon: _unref(mdiClose),
                                                color: "primary",
                                                class: "cursor-pointer ml-1",
                                                onClick: ($event: any) => (cancelEditName(item))
                                              }, null, 8, ["icon", "onClick"])
                                            ]))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          icon: _unref(mdiCloseCircleOutline),
                                          color: "#2F7F91",
                                          class: "cursor-pointer",
                                          onClick: ($event: any) => (removeFile(index))
                                        }, null, 8, ["icon", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { style: {"display":"flex","width":"100%","justify-content":"space-between","padding":"1.5rem"} }, {
                  default: _withCtx(() => [
                    _createVNode(OutlinedButton, {
                      onClick: closeFilesModal,
                      text: "Voltar",
                      height: "48px",
                      width: "74px"
                    }),
                    _createVNode(FilledButton, {
                      disabled: !isFormValid.value,
                      onClick: submitFiles,
                      text: "Salvar",
                      variant: "flat",
                      color: "primary",
                      size: "large",
                      height: "48px",
                      width: "180px",
                      class: "!bg-[#337C88]"
                    }, null, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: showFilesModal.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showFilesModal).value = $event)),
      "max-width": "700"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, {
              class: "text-h6 pa-4",
              style: {"position":"relative"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isReadOnly.value ? 'Anexos' : 'Evidências') + " ", 1),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  onClick: closeFilesModal,
                  style: {"position":"absolute","right":"8px","top":"8px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      icon: _unref(mdiClose),
                      size: "24"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { style: {"padding":"16px !important"} }, {
              default: _withCtx(() => [
                (modalFiles.value && modalFiles.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modalFiles.value, (file, idx) => {
                        return (_openBlock(), _createBlock(_component_v_row, {
                          key: idx,
                          class: "ma-0 border-b pl-4 pr-2 flex-nowrap",
                          style: {"height":"72px"},
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "auto",
                              style: {"display":"flex","align-items":"center","margin-right":"20px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "40",
                                  color: "primary",
                                  icon: _unref(mdiFileOutline)
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { style: {"display":"flex","flex-direction":"column","justify-content":"center","height":"100%","min-width":"0","flex-grow":"1"} }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "font-weight-bold text-truncate",
                                  title: file.name,
                                  style: {"line-height":"1.2"}
                                }, _toDisplayString(file.name), 9, _hoisted_132),
                                (file.size)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_133, _toDisplayString(formatBytes(file.size)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, {
                              cols: "auto",
                              style: {"display":"flex","align-items":"center","padding-left":"12px"}
                            }, {
                              default: _withCtx(() => [
                                (file.eventType)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_134, _toDisplayString(eventTypeLabel(file.eventType)), 1))
                                  : _createCommentVNode("", true),
                                (file.id)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      icon: "",
                                      variant: "text",
                                      color: "primary",
                                      onClick: _withModifiers(($event: any) => (downloadEvidence(file.id)), ["stop"]),
                                      style: {"display":"flex","align-items":"center","justify-content":"center"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          size: "32",
                                          icon: _unref(mdiTrayArrowDown)
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { style: {"width":"100%","display":"flex","justify-content":"flex-end","padding":"16px"} }, {
              default: _withCtx(() => [
                _createVNode(OutlinedButton, {
                  onClick: closeFilesModal,
                  text: "Fechar",
                  height: "48px",
                  width: "74px",
                  style: {"border":"2px solid currentColor","font-weight":"bold"}
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})